var map = {
	"./1hittoms.png": 11218,
	"./2pzontwos.png": 42868,
	"./3samsamdrez.png": 64492,
	"./4colosoltz.png": 13213,
	"./5illuvil.png": 51216,
	"./6zyutzots.png": 81344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79733;